import useAuth, { useComplianceContext } from "./useContexts";
import { ICompanyDetails } from "@/types/user.interface";

export function useAuthDetails() {
  const { auth } = useAuth();
  const { compliance, complianceKnown } = useComplianceContext();

  const company: Partial<ICompanyDetails> = auth?.user?.company ?? {};

  // MED-725: the four gating values come from the compliance endpoint alone.
  // They used to be re-derived here from the company object captured at login,
  // which never refreshed for the life of a session. `restricted` already has
  // the commercial-account qualifier applied on the backend, so company type is
  // no longer consulted for gating — only for display.
  const isCompanyApproved = compliance.company_approved;
  const hasValidLicence = compliance.licence_valid;
  const hasFullAccess = compliance.compliant;
  const isRestricted = compliance.restricted;

  return {
    firstName: auth?.user?.first_name,
    middleName: auth?.user?.middle_name,
    lastName: auth?.user?.last_name,
    email: auth?.user?.email,
    companyAddress: company.corporate_address,
    address: auth?.user?.address,
    phone: auth?.user?.phone_number,
    companyName: company.name,
    companyId: company.id,
    role: auth?.user?.roles?.[0]?.title,
    userId: auth?.user?.id,
    isCompanyApproved,
    companyType: auth?.user?.user_company_type,
    emailVerified: auth?.user?.email_verified,
    phoneVerified: auth?.user?.phone_verified,
    companyApprovalStatus: company.approval_status,
    companyApprovalRemark: company.remark,
    apiKey: company.api_key,
    pcnRegistrationStatus: company.pcn_registration_status,
    pcnVerificationStatus: company.pcn_verification_status,
    currentPcnLicenceExpDate: company.current_pcn_licence_exp_date,
    hasValidLicence,
    hasFullAccess,
    isRestricted,
    complianceKnown,
    goodsReceivedNotificationUrl: company.settings?.goods_received_notification_url,
  };
}
